import { styled } from '@linaria/react';
import { fonts, primitives, semantic, size, space } from '../../theme/tokens';

export const Pill = styled.button`
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.medium};
  line-height: ${primitives.typography.lineHeight.normal};
  letter-spacing: ${primitives.typography.tracking.normal};
  padding: ${space['space-300']} ${space['space-500']};
  border-radius: ${size.radius['radius-sm']};
  border: ${size.stroke['stroke-default']} solid ${semantic.border.default};
  background: transparent;
  color: ${semantic.text.primary};
  box-sizing: border-box;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
  white-space: nowrap;

  &:hover {
    background: ${semantic.bg.surfaceSubtle};
  }

  &[data-selected='true'] {
    background: ${semantic.bg.brand};
    color: ${semantic.text.inverse};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &[data-variant='display'] {
    font-size: ${fonts.size.xs};
    font-weight: ${fonts.weight.normal};
    padding: ${space['space-200']} ${space['space-300']};
    border: none;
    background: ${semantic.bg.surfaceSubtle};
    color: ${semantic.text.primary};
    cursor: default;
  }
`;
